export const EMPLOYEE_ROLE = "employee";
export const EMPLOYER_ROLE = "employer";
export const EXPERT_ROLE = "expert";
export const CANDIDATE_ROLE = "candidate";

export const ROLE = {
  [EMPLOYEE_ROLE]: EMPLOYEE_ROLE,
  [EMPLOYER_ROLE]: EMPLOYER_ROLE,
  [EXPERT_ROLE]: EXPERT_ROLE,
  [CANDIDATE_ROLE]: CANDIDATE_ROLE,
};

export enum ROLES {
  EMPLOYEE_ROLE,
  EMPLOYER_ROLE,
  EXPERT_ROLE,
  CANDIDATE_ROLE,
}

export const EMPLOYEE_ROLE_LABEL = "Employee";
export const EMPLOYER_ROLE_LABEL = "Employer";
export const EXPERT_ROLE_LABEL = "Expert";
export const CANDIDATE_ROLE_LABEL = "Candidate";

export const ROLE_LABELS = {
  [EMPLOYEE_ROLE]: EMPLOYEE_ROLE_LABEL,
  [EMPLOYER_ROLE]: EMPLOYER_ROLE_LABEL,
  [EXPERT_ROLE]: EXPERT_ROLE_LABEL,
  [CANDIDATE_ROLE]: CANDIDATE_ROLE_LABEL,
};
